module.exports = __webpack_public_path__ + "static/media/assicurazioni-mobile.6221e155.svg";